import { orderBy, trim } from 'lodash-es';
import {
  DELETE_WELCOME_IDS,
  GET_LOCALMACHINEINFO_SUCCESS,
  // GET_LOCALSOFT_INIT_SUCCESS,
  GET_LOCALSOFT_SUCCESS,
  GET_OTHER_INFO,
  SET_OTHER_INFO,
  SET_QUIET_INSRALL_PATH,
  REMOVE_UNINSTALL_SOFT,
  REQUEST_NATIVE_UPGRADE,
  SET_COMMAND_LINE,
  SET_WELCOME_IDS,
  SILENT_SOFT_INSTALL_INFOS_SUCCESS,
  SET_UPDATE_NOTIFY_STATUS,
} from '../constants/native';
import {
  ADD_UNINSTALL,
  CANCEL_UNINSTALL,
  SET_SIZE_SORT,
  SET_TIME_SORT,
} from '../constants/unintall';
import { camelizeObj, logNative } from '../utils/utils';

const initState = {
  machineInfo: null,
  installedSoft: [],
  installedSoftInit: [],
  upgradeSofts: null,
  upgradeSoftsAll: null,
  otherInfo: null,
  commandLine: null,
  uninstallSoft: [],
  ids: null,
  supportSilentInstSoft: null,
  quietInstallPath: {
    definstallpath: `D:\\AppStoreInstalled\\`,
    installpath: `D:\\AppStoreInstalled\\`,
    diskfreesize: '0',
  },
  productRecommendInfo: [], // 竞品引流数据,
  updateNotifyStatus: false, // 升级弹窗开关
};

const native = (state = initState, action = {}) => {
  let tmp = null;
  const initSoft = [];
  switch (action.type) {
    case GET_LOCALMACHINEINFO_SUCCESS:
      return {
        ...state,
        machineInfo: action.payload,
      };

    case GET_LOCALSOFT_SUCCESS:
      action.payload.forEach(v => {
        tmp = v;
        // tmp.sortTime = Number(v.installdate);
        tmp.sortTime = +new Date(v.installdate) || parseInt(v.installdate, 10);
        tmp.sortSize = Number(v.estimateSize);
      });
      return {
        ...state,
        installedSoft: orderBy([...action.payload], ['sortTime', 'sortSize'], ['desc']),
      };

    // case GET_LOCALSOFT_INIT_SUCCESS:
    //   return {
    //     ...state,
    //     installedSoftInit: orderBy([...action.payload], ['sortTime', 'sortSize'], ['desc']),
    //   };

    case SET_TIME_SORT:
      tmp = orderBy(state.installedSoft, ['sortTime', 'sortSize'], ['desc']);
      return {
        ...state,
        installedSoft: tmp,
      };

    case SET_SIZE_SORT:
      // 软件大小
      tmp = orderBy(state.installedSoft, ['sortSize', 'sortTime'], ['desc']);
      return {
        ...state,
        installedSoft: tmp,
      };
    case REMOVE_UNINSTALL_SOFT:
      tmp = state.installedSoft.filter(v => {
        if (
          action.result.androidType === '1' &&
          v.androidType === '1' &&
          v.packageName === action.result.packageName
        ) {
          return false;
        }
        if (
          action.result.androidType !== '1' &&
          v.androidType !== '1' &&
          v.softGUID === action.result.softGUID &&
          v.isx64 === action.result.isx64
        ) {
          return false;
        }
        return true;
      });
      return { ...state, installedSoft: tmp };
    case REQUEST_NATIVE_UPGRADE:
      tmp = [];
      action.upgradeSofts.forEach(v => {
        tmp.push(camelizeObj(v));
      });
      logNative(`大写转小写结果：`, { old: action.upgradeSofts, new: tmp }, true, true);
      // 初始的本地已安装列表(显示打开列表，不包含更新)，存在就不再更新不存在就生成这个别表。
      if (state.installedSoftInit && state.installedSoftInit.length > 0) {
        return {
          ...state,
          upgradeSofts: tmp.filter(soft => !soft.bIgnore) || [],
          // upgradeSofts: tmp,
          upgradeSoftsAll: tmp || [],
        };
      }
      state.installedSoft.forEach(item => {
        const found = tmp.find(
          soft =>
            // 过滤本地列表中是更新的软件（忽略更新的软件不过滤），此本地列表用于过滤展示（即：过滤已安装但不是可更新的软件）
            (item.androidType !== '1' &&
              (soft.softID === item.softID || soft.softID === item.SoftID) &&
              !soft.bIgnore) ||
            (item.androidType === '1' && soft.packageName === item.packageName && !soft.bIgnore),
        );
        if (found === undefined) {
          initSoft.push(item);
        }
      });
      return {
        ...state,
        upgradeSofts: tmp.filter(soft => !soft.bIgnore) || [],
        // upgradeSofts: tmp,
        upgradeSoftsAll: tmp || [],
        installedSoftInit: initSoft,
      };
    case GET_OTHER_INFO:
      return { ...state, otherInfo: action.otherInfo };
    case SET_OTHER_INFO:
      return {
        ...state,
        otherInfo: {
          ...state.otherInfo,
          ...action.otherInfo,
        },
      };
    case SET_QUIET_INSRALL_PATH:
      return {
        ...state,
        quietInstallPath: {
          definstallpath: action.definstallpath || 'D:\\AppStoreInstalled\\',
          installpath: action.installpath,
          diskfreesize: action.diskfreesize,
        },
      };
    case SET_COMMAND_LINE:
      return {
        ...state,
        commandLine: action.commandLine,
      };
    case SET_WELCOME_IDS:
      tmp = trim(action.ids, ' ,');
      if (tmp && tmp.length > 0) {
        return {
          ...state,
          ids: tmp.split(','),
        };
      }
      return {
        ...state,
        ids: [],
      };

    case DELETE_WELCOME_IDS:
      return {
        ...state,
        ids: [],
      };
    case ADD_UNINSTALL:
      tmp = state.uninstallSoft.find(
        v =>
          (v.androidType !== '1' && v.softGUID === action.soft.softGUID) ||
          (v.androidType === '1' && v.packageName === action.soft.packageName),
      );
      if (!tmp) {
        return { ...state, uninstallSoft: [...state.uninstallSoft, action.soft] };
      }
      return state;
    case CANCEL_UNINSTALL:
      tmp = state.uninstallSoft.filter(
        v =>
          (v.androidType !== '1' && v.softGUID !== action.soft.softGUID) ||
          (v.androidType === '1' && v.packageName !== action.soft.packageName),
      );
      return { ...state, uninstallSoft: [...tmp] };
    case SILENT_SOFT_INSTALL_INFOS_SUCCESS:
      return {
        ...state,
        supportSilentInstSoft: action.supportSilentInstSoft,
        productRecommendInfo: action.productRecommendInfo,
      };
    case SET_UPDATE_NOTIFY_STATUS:
      return {
        ...state,
        updateNotifyStatus: action.payload,
      };
    default:
      return state;
  }
};

export default native;
